import { call, put } from 'redux-saga/effects';
import ApprovalsApi from '../api/ApprovalsApi';
import StageApi from '../api/StageApi';
import BoxSoftwareApi from '../api/BoxSoftwareApi';
import updateApprovalsPendingCount from '../actions/updateApprovalsPendingCount';
import updateNewStagesCount from '../actions/updateNewStagesCount';
import updateNewSoftwareVersionsCount from '../actions/updateNewSoftwareVersionsCount';

export default function* loadBadgeCountSaga() {
    try {
        const approvalsResponse = yield call(ApprovalsApi.CountPending);
        const stagesResponse = yield call(StageApi.CountNewStages);
        const streamboxNewSoftwareVersions = yield call(BoxSoftwareApi.CountNewSoftwareVersions);
        yield put(updateNewStagesCount(stagesResponse.data.count));
        yield put(updateApprovalsPendingCount(approvalsResponse.data.count));
        yield put(updateNewSoftwareVersionsCount(streamboxNewSoftwareVersions.data.data.length));
    } catch (error) {}
}
